import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import {errorRaised} from "@mnjsplatform/data/lib/actions/errorActions";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";

class RequestDialog2 extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {showMessage: false};
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            //await this.props.dispatch(this.props.dataItem.beginAdd(key));
        } catch (e) {
            console.error(e);
        }
    }

    onClose = async () => {
        console.log(`rowInEditIndex=${this.props.dataItem.rowInEditIndex}`);
        if (!this.props.readOnly) {
            if (this.props.addMode) {
                await this.props.dispatch(this.props.dataItem.cancelAdd());
            } else {
                await this.props.dispatch(this.props.dataItem.cancelEdit());
            }
        }
        if (!this.props.dataItem.isError) {
            if (this.props.onClose)
                this.props.onClose();
        }
    }

    saveRow = async () => {
        console.log(`rowInEditIndex=${this.props.dataItem.rowInEditIndex}`);
        try {
            if (this.props.addMode) {
                await this.props.dispatch(this.props.dataItem.saveAdd(this.props.dataItem.rowInEditIndex));
            } else {
                await this.props.dispatch(this.props.dataItem.save(this.props.dataItem.rowInEditIndex));
            }
        } catch (error) {
            this.props.dispatch(errorRaised(error))
        }
    }

    printRequest = async (rowKey) => {
        if (this.props.onPrint) {
            await this.props.onPrint(rowKey);
        }
    }

    processRequest = async () => {
        //console.log(`rowInEditIndex=${this.props.dataItem.rowInEditIndex}`);
        const rowIndex = this.props.dataItem.rowInEditIndex;
        if (!this.props.readOnly) {
            await this.saveRow();
        }
        if (!this.props.dataItem.isError) {
            const row = this.props.dataItem.getRow(rowIndex);
            const rowKey = this.props.dataItem.getRowKey(row);
            if (this.props.isEkdo) {
                this.setState({showMessage: true});
                await this.props.dispatch(this.props.CompHolidayApp_Send.execute(rowKey));
                this.setState({showMessage: false});
            } else {
                await this.printRequest(rowKey);
            }
            if (this.props.onClose)
                await this.props.onClose();
        }
    }

    renderButtons = () => {
        return (<div className="modal-footer text-center">
            {
                ((this.props.isEkdo && !this.props.readOnly) || !this.props.isEkdo) &&
                <button className="btn btn-regular -goahead ml1ex mb-2" disabled={this.state.showMessage}
                        onClick={this.processRequest}>{i18next.t((this.props.isEkdo ? "Sign_Send_Request" : "DayOff_PrintStatement"))}
                </button>
            }
            <button className="btn btn-regular" disabled={this.state.showMessage}
                    onClick={this.onClose}>{i18next.t('Cancel')}
            </button>
        </div>)
    }

    render() {
        if(!this.props.dataItem.isInitialized)
            return null;

        const title = i18next.t((this.props.addMode ? "NewRequest" : "Edit_Request"));
        const placeholderId = (this.props.addMode ? "11" : "12");
        return (
            <PopupWrapper popupVisible={true} title={title} onClose={this.onClose}
                          renderButtons={this.renderButtons} maxWidthBody='500px' minHeightBody='200px'
                          instructionId={placeholderId}>
                <ComplexParam dataItem={this.props.dataItem} rowIndex={this.props.rowIndex}
                              showApplyButton={false} showSearchBar={false} readOnly={this.props.readOnly}
                              renderParams={paramRender}
                />
                {this.state.showMessage &&
                    <div className="text-center">
                        <span className="alert-info">{i18next.t('Vacation_SendRequest')}</span>
                    </div>
                }
            </PopupWrapper>
        )
    }
}

RequestDialog2.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    onClose: PropTypes.func,
    isEkdo: PropTypes.bool,
    readOnly: PropTypes.bool,
    rowKey: PropTypes.object,
    row: PropTypes.object,
    onPrint: PropTypes.func,
    CompHolidayApp_Send: PropTypes.object,
    CompHolidayApp_PrintPO: PropTypes.object,
    addMode: PropTypes.bool,
    rowIndex: PropTypes.number
}

RequestDialog2.defaultProps = {
    isEkdo: false,
    addMode: false
}

function mapStateToProps(state, ownProps) {
    return {
        CompHolidayApp_Send: state.dayOffState.CompHolidayApp_Send,
        CompHolidayApp_PrintPO: state.dayOffState.CompHolidayApp_PrintPO
    }
}

export default connect(mapStateToProps)(RequestDialog2)